<template>
  <div 
    @mouseover="toggleMenu(false)" 
    @mouseleave="toggleMenu(true)">
    <v-navigation-drawer
      class="main-nav"
      fixed
      permanent
      app
      :mini-variant.sync="drawerRoute"
      :width="smAndDown ? '260' : '290'"
      :mini-variant-width="70"
    >
      <div class="logo">
        <icon name="logo-icon" />
        <icon name="logo-text" />
      </div>
      <ul>
        <li
          v-for="(link, idx) in visibleMenu"
          :key="idx"
          @click="toggleSubmenu(idx)"
          :class="{
            'show-submenu': submenuActiveIndex === idx,
            'active': isActive(link),
            }"
        >
          <router-link :to="{ name: link.route }">
            <i class="fal" :class="{['fa-' + link.icon] : link.icon}"></i>
            <span>{{ link.text }}</span>
            <i v-if="link.children" class="fal fa-angle-down arrow"></i>
          </router-link>
          <ul v-if="link.children">
            <li
              v-for="(child, childIndex) in link.children"
              :key="`${idx}-${childIndex}`"
              :class="{'active': isActive(child)}"
            >
              <router-link :to="{ name: child.route }">
                <span>{{ child.text }}</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <a href="javascript:void(0)" class="nav-dummy">
            <i class="fal fa-lightbulb-dollar"></i>
            <span>Sale</span>
          </a>
        </li>
      </ul>
      <div class="user">
        <div class="user-avatar">
          <img :src="showAvatar" alt="avatar" />
        </div>
        <div class="user-info">
          <strong class="user-info-nickname">{{ user.firstName }} {{ user.lastName }}</strong>
          <div class="user-info-text">{{ printName(user.userGroup, 'userGroups') }}</div>
        </div>
        <div class="user-logout">
          <a href="#" @click="logout" class="logout" title="Logout">
            <i class="fal fa-power-off"></i>
          </a>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { SET_DRAWER } from "@/store/mutation-types";
import { LOGOUT } from "@/store/action-types";
import Vue from "vue";
const { $gettext } = Vue.prototype;

export default {
  name: "Navigation",
  data() {
    return {
      submenuActiveIndex: undefined,
      deviceDummyDrawer: null
    };
  },
  computed: {
    drawerRoute: {
      get() {
        if(this.smAndDown) {
          return false;
        }
        return this.$store.state.toggle.drawer;
      },
      set(value) {
        if(this.smAndDown) {
        } else {
          this.$store.state.toggle.drawer = value;
        }
      }
    },
    visibleMenu() {
      return this.$store.getters.getVisibleMenu(this.can);
    },
    showAvatar() {
      return this.user.picture ? location.protocol + "//" + location.hostname + "/api/" + this.user.picture : 'assets/img/avatar-default.jpg';
    },
    ...mapState({
      user: state => state.auth.user,
      menu: state => state.auth.menu,
      drawer: state => state.toggle.drawer
    })
  },
  methods: {
    isActive(item) {
      if (item.route && item.route === this.$router.currentRoute.name) {
        return true;
      }
      if (item.children) {
        let isMatch = false;
        item.children.forEach(child => {
          if (child.route && child.route === this.$router.currentRoute.name) {
            isMatch = true;
          }
        });
        return isMatch;
      }
      return false;
    },
    isActiveFromChild(item) {
      if (item.children) {
        let isMatch = false;
        item.children.forEach(child => {
          if (child.route && child.route === this.$router.currentRoute.name) {
            isMatch = true;
          }
        });
        return isMatch;
      }
      return false;
    },
    toggleMenu(status) {
      if(this.smAndDown) return;
      this.$store.commit(SET_DRAWER, status);
    },
    toggleSubmenu(itemIndex) {
      this.submenuActiveIndex = itemIndex;
    },
    ...mapActions([LOGOUT])
  },
  watch: {
    $route() {
      this.$forceUpdate();
    }
  }
};
</script>
